import { connect } from 'react-redux'
import SharesView from './view';
import { fetchShareForContact } from 'src/legacy/redux/actions/rolodex.jsx';
import { fetchPreviewAsset } from 'src/legacy/redux/actions/assets.jsx';
import withUseHooks from 'src/legacy/components/withUseHooks';

const mapStateToProps = (state,ownProps) => {
  var id = ownProps.id 

  var shares = state.legacyRootReducer.rolodex.contact.shares.items || [];
  var share = shares.find(item => item.id == id);

  return {
    share: share,
    user: state.users.me
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchShareForContact: (id, share) => {
      return dispatch(fetchShareForContact(id, share));
    },

    fetchPreviewAsset: (assetID) => {
      return dispatch(fetchPreviewAsset(assetID));
    }
  }
}

const SharesViewContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(SharesView)

export default withUseHooks(SharesViewContainer);